import React, { useState, useEffect } from 'react';
import { Col, Typography, Row, Card, Button, Modal, Image, Layout } from 'antd';
import styled from 'styled-components';
import clip from 'src/sounds/clip-sound.mp3';
import clipGood from 'src/sounds/Good_job.mp3';
import clipTry from 'src/sounds/Try Again.mp3';
import 'react-simple-keyboard/build/css/index.css';
import useSound from 'use-sound';
import ReactPlayer from 'react-player';
import { StarOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { isMobileOnly } from 'react-device-detect';
import { ImgButton } from 'src/components/Header/toolHeaderstyle';
import { useHistory } from 'react-router-dom';
import FullScreenButton from 'src/components/common/FullScreenButton';
const { Header: HeaderWrapper } = Layout;
const { Title } = Typography;

const MainBlock = styled.div`
  padding: 10px;
  margin-top: 10px;
  background: #fff;
  height: calc(100vh - 94px);
`;

const TotalBox = styled.span`
  color: rgb(255, 122, 27);
  border: 1px solid #6b5c5c;
  padding: 5px 10px;
  border-radius: 5px;
  font-size: ${(props) => props.isMobile && '14px'} !important;
`;

const ScoreBox = styled.span`
  color: #de3333;
  border: 1px solid #de3333ab;
  padding: 5px 10px;
  border-radius: 5px;
  font-size: ${(props) => props.isMobile && '14px'} !important;
`;

const LCQuizPage = ({ onClickGoback, type, data = [], preset, handleSaveExit, dataUserStudy }) => {
  const [total, setTotal] = useState(data.study_quiz_data.length);
  const [score, setScore] = useState(0);
  const [done, setDone] = useState(type);
  const [complete, setComplete] = useState(0);
  const [ans, setAns] = useState('');
  const [ques, setQues] = useState('');
  const [error, setError] = useState(-1);
  const [errorList, setErrorList] = useState([]);
  const [correct, setCorrect] = useState(-1);
  const [playing, setPlaying] = useState(false);
  const [nowSound, setNowSound] = useState(false);
  const [options, setOptions] = useState([]);
  const [listenFinish, setListenFinish] = useState(false);
  const [mobileModal, setMobileModal] = useState(false);
  const [answerSheet, setAnswerSheet] = useState([]);
  const history = useHistory();
  const [play] = useSound(clip);
  const [playGood] = useSound(clipGood, {
    onend: () => {
      setNowSound(false);
    },
  });
  const [playTry] = useSound(clipTry);
  useEffect(() => {
    if (done !== -1) {
      if (data && data.study_quiz_data[done] && !nowSound) {
        setQues(data.study_quiz_data[done].question);
        setAns(parseInt(data.study_quiz_data[done].answer));
        setOptions(data.study_quiz_data[done].option_list);
        setError(-1);
        setCorrect(-1);
        setPlaying(false);
      }
    }
  }, [done, data]);
  useEffect(() => {
    if (
      dataUserStudy &&
      dataUserStudy.getUserStudyCompleteList &&
      dataUserStudy.getUserStudyCompleteList[0]?.user_study_answer?.length >= 0 &&
      dataUserStudy.getUserStudyCompleteList[0]?.stat === 0
    ) {
      const lastStudyData = dataUserStudy.getUserStudyCompleteList[0]?.user_study_answer;
      const lastIdx = lastStudyData.findIndex((v) => v.user_answer === '');
      let tmpscore = 0;
      const tmp = data?.study_quiz_data?.map((e) => {
        let findAnswer = lastStudyData.find((a) => a.question_no === e.no);
        if (findAnswer && findAnswer.is_correct === '1') {
          tmpscore += (1 / total) * 100;
        }
        return {
          question_no: e.no,
          user_answer: findAnswer && findAnswer.user_answer !== '' ? findAnswer.user_answer : '',
          is_correct: findAnswer ? findAnswer.is_correct : '0',
        };
      });
      setScore(tmpscore);
      setAnswerSheet(tmp);
      setComplete(lastIdx === -1 ? 0 : lastIdx);
      setDone(lastIdx === -1 ? 0 : lastIdx);
    } else {
      const tmp = data?.study_quiz_data?.map((e) => {
        return {
          question_no: e.no,
          user_answer: '',
          is_correct: '0',
        };
      });
      setAnswerSheet(tmp);
    }
  }, [dataUserStudy, data]);
  const handleAnswerClick = (val, i) => {
    setPlaying(false);
    if (error !== -1 || correct !== -1) return;
    if (i + 1 === ans) {
      setNowSound(true);
      playGood();
      setError(-1);
      setCorrect(i);
      const tmp = [...answerSheet];
      tmp[done].user_answer = String(i + 1);
      tmp[done].is_correct = '1';
      setAnswerSheet(tmp);
      let newscore = score;
      newscore += (1 / total) * 100;
      setScore(newscore);
      goNext(newscore);
    } else {
      setCorrect(ans - 1);
      setError(i);
      const tmp = [...answerSheet];
      tmp[done].user_answer = String(i + 1);
      tmp[done].is_correct = '0';
      setAnswerSheet(tmp);
      errorList.push({ done });
      setErrorList(errorList);
      // playTry()
      goNext();
    }
  };
  const goNext = (newscore = null) => {
    if (done < data.study_quiz_data.length) {
      // setDone(done < data.length ? done + 1 : data.length);
      setComplete(complete + 1);
    } else {
      setTimeout(() => {
        if (onClickGoback) {
          const curScore = newscore ? Math.round(newscore) : Math.round(score);
          Modal.info({
            content: `Your total score is ${newscore ? Math.round(newscore) : Math.round(score)}`,
            onOk: () =>
              onClickGoback({
                exam_total: 100,
                exam_correct: curScore > 100 ? 100 : curScore,
                message: `Your total score is ${newscore ? Math.round(newscore) : Math.round(score)}`,
                user_answers: answerSheet,
              }),
          });
        }
      }, 1000);
    }
  };
  const goNextIndx = () => {
    setPlaying(false);
    if (complete === total) {
      if (onClickGoback) {
        const curScore = Math.round(score);

        Modal.info({
          content: `Your total score is ${Math.round(score)}`,
          onOk: () =>
            onClickGoback({
              exam_total: 100,
              exam_correct: curScore > 100 ? 100 : curScore,
              message: `Your total score is ${Math.round(score)}`,
              user_answers: answerSheet,
            }),
        });
      }
    } else if (done < data.study_quiz_data.length - 1 && (done === -1 || complete > done)) {
      setDone(done + 1);
    }
  };
  const onPlayEnd = () => {
    setPlaying(false);
    setListenFinish(true);
  };
  const handleCloseClick = () => {
    if (complete === total) {
      if (onClickGoback) {
        const curScore = Math.round(score);

        Modal.info({
          content: `Your total score is ${Math.round(score)}`,
          onOk: () =>
            onClickGoback({
              exam_total: 100,
              exam_correct: curScore > 100 ? 100 : curScore,
              message: `Your total score is ${Math.round(score)}`,
              user_answers: answerSheet,
            }),
        });
      }
    } else {
      Modal.confirm({
        icon: null,
        title: 'Exit',
        content: (
          <Title level={4} style={{ textAlign: 'center', lineHeight: 2 }}>
            학습이 완료되지 않았습니다. <br /> 종료하면 지금 학습하던 문제부터 <br />
            이어서 학습합니다. <br /> 종료 하시겠습니까?
          </Title>
        ),
        onOk: () => {
          handleSaveExit({ user_answers: answerSheet });
          history.push('/');
        },
      });
    }
  };
  console.log(type,'type')
  return (
    <>
      <HeaderWrapper
        style={{
          background: '#fff',
          paddingLeft: 10,
          paddingRight: 10,
          display: 'flex',
          justifyContent: 'space-between',
          position: 'relative',
          width: '100%',
          height: isMobileOnly && 50,
          lineHeight: isMobileOnly && '50px',
        }}
      >
        <div style={{ paddingTop: 10 }}>
          <Title level={2} style={{ marginLeft: 20, textTransform: 'capitalize', fontSize: isMobileOnly && 20 }}>
            Listening Comprehension
          </Title>
        </div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {isMobileOnly && (
            <div style={{ backgroundColor: '' }}>
              <FullScreenButton
                element={<ImgButton className="header-btn" src="/images/fullscreen_blue.png" alt="back arrow in header" />}
                activeElement={<ImgButton className="header-btn" src="/images/fullscreenExit_blue.png" alt="back arrow in header" />}
              />
            </div>
          )}
          <div key="close" onClick={handleCloseClick}>
            <span style={{ color: '#999', cursor: 'pointer' }}>
              <CloseCircleOutlined
                style={{
                  marginRight: 20,
                  verticalAlign: 'middle',
                  fontSize: 25,
                  color: '#424242',
                }}
                key="close"
              />
            </span>
          </div>
        </div>
      </HeaderWrapper>
      {done !== -1 && mobileModal && (
        <Modal
          title={'Audio'}
          visible={mobileModal}
          width={'80%'}
          footer={null}
          onCancel={() => {
            setMobileModal(false);
            setPlaying(false);
          }}
        >
          <ReactPlayer
            url={`https://cdn.cloubot.com/EVN/middle/${preset}/audio/${data?.study_quiz_data[type === -1 ? 0 : done]['question_audio']}`}
            // width="0"
            controls={true}
            height="50px"
            playing={playing && mobileModal}
            onEnded={onPlayEnd}
            config={{
              file: {
                attributes: {
                  controlsList: 'nodownload noplaybackrate',
                },
              },
            }}
          />
        </Modal>
      )}
      <Col className="quiz-fluid-container" span={24} style={{ textAlign: 'left', margin: 0 }}>
        {done === -1 ? (
          <MainBlock className="quiz-fluid-scroll">
            <Row gutter={[24, 16]} style={{ padding: 10 }}>
              <Col className="quiz-heading" span={16}>
                <Row gutter={[24, 16]} style={{ margin: 0 }}>
                  <Col className="quiz-heading-containt" span={24} style={{ padding: 10, paddingLeft: 10 }}>
                    <Title level={2} ellipsis>
                      <span style={{ color: '#065aa9', marginLeft: 10, fontSize: isMobileOnly && 16 }}>
                        Listen carefully and choose the correct answer.
                      </span>{' '}
                    </Title>
                  </Col>
                </Row>
              </Col>
              <Col
                className="quiz-heading-listing"
                span={8}
                style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', paddingRight: 10 }}
              >
                <Button disabled={!listenFinish} onClick={goNextIndx} type="primary" value="large">
                  Next
                </Button>
              </Col>
            </Row>
            <Row gutter={[24, 16]} style={{ padding: 10, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              {isMobileOnly && (
                <Image
                  height={60}
                  width={60}
                  style={{ cursor: 'pointer' }}
                  src="/images/speak.png"
                  preview={false}
                  onClick={() => setPlaying(true)}
                />
              )}
              <Col
                className={'word-board imagequizspeaker'}
                span={16}
                style={{ padding: 10, display: 'flex', flexDirection: 'column', justifyContent: 'space-evenly', alignItems: 'flex-start' }}
              >
                <Card
                  style={{
                    width: '100%',
                    borderRadius: 20,
                    boxShadow: '10px 10px 5px 5px rgba(95, 77, 99, 0.5)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                  bodyStyle={{
                    background: '#fff',
                    borderRadius: 20,
                    minHeight: '300px',
                    display: 'flex',
                    cursor: 'default',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                  hoverable
                  loading={false}
                >
                  <Image
                    height={60}
                    width={60}
                    style={{ cursor: 'pointer' }}
                    src="/images/speak.png"
                    preview={false}
                    onClick={() => setPlaying(true)}
                  />
                  <ReactPlayer
                    url={`https://cdn.cloubot.com/EVN/middle/${preset}/audio/${data?.study_quiz_data[0]['question_audio']}`}
                    width="0"
                    height="0"
                    playing={playing}
                    onEnded={onPlayEnd}
                  />
                </Card>
              </Col>
            </Row>
          </MainBlock>
        ) : (
          <MainBlock className="quiz-fluid-scroll">
            <Row gutter={[24, 16]} style={{ padding: 10 }}>
              <Col className="quiz-heading" span={16}>
                <Row gutter={[24, 16]} style={{ margin: 0 }}>
                  <Col className="quiz-heading-containt" span={24} style={{ padding: 10, paddingLeft: 10 }}>
                    <Title level={2} ellipsis>
                      <span style={{ color: '#065aa9', marginLeft: 10, fontSize: isMobileOnly && 16 }}>
                        Listen carefully and choose the correct answer.
                      </span>{' '}
                    </Title>
                  </Col>
                </Row>
              </Col>
              <Col
                className="quiz-heading-listing"
                span={8}
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'center',
                  paddingLeft: isMobileOnly && 0,
                  paddingRight: 10,
                }}
              >
                <Title level={4} style={{ margin: 0, marginLeft: 10, marginRight: 10 }}>
                  <ScoreBox isMobile={isMobileOnly}>Score : {Math.round(score)}</ScoreBox>{' '}
                </Title>
                <Title level={4} style={{ margin: 0, marginLeft: 10, marginRight: 10 }}>
                  <TotalBox isMobile={isMobileOnly}>
                    {done + 1} / {total}
                  </TotalBox>
                </Title>
                {complete <= done ? (
                  <Button
                    onClick={() => {
                      setMobileModal(true);
                    }}
                    value="large"
                  >
                    Play
                  </Button>
                ) : (
                  <Button disabled={complete <= done} onClick={goNextIndx} type="primary" value="large">
                    Next
                  </Button>
                )}
              </Col>
            </Row>
            <Row gutter={[24, 16]} style={{ padding: 10 }}>
              <Col
                className={isMobileOnly ? 'word-board imagequizspeaker middle-box-mobile' : 'word-board imagequizspeaker'}
                span={10}
                style={{ padding: 10, display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    marginTop: isMobileOnly ? 0 : 60,
                    marginBottom: isMobileOnly ? 0 : 15,
                  }}
                >
                  {/* <Image
                    height={50}
                    width={50}
                    style={{ cursor: 'pointer' }}
                    src="/images/speak.png"
                    preview={false}
                    onClick={() => setPlaying(true)}
                  /> */}
                  {!isMobileOnly && (
                    <ReactPlayer
                      url={`https://cdn.cloubot.com/EVN/middle/${preset}/audio/${data?.study_quiz_data[type === -1 ? 0 : done]['question_audio']}`}
                      // width="0"
                      controls={true}
                      height="50px"
                      playing={playing}
                      onEnded={onPlayEnd}
                      config={{
                        file: {
                          attributes: {
                            controlsList: 'nodownload noplaybackrate',
                          },
                        },
                      }}
                    />
                  )}
                </div>
                {data?.study_quiz_data[done]['question_type'] === 'C' ? (
                  <Card
                    style={{
                      width: '100%',
                      borderRadius: 20,
                      boxShadow: '10px 10px 5px 5px rgba(95, 77, 99, 0.5)',
                      justifyContent: 'center',
                      alignItems: 'center',
                      display: 'flex',
                    }}
                    bodyStyle={{
                      background: '#fff',
                      borderRadius: 20,
                      minHeight: '300px',
                      display: 'flex',
                      cursor: 'default',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                    hoverable
                    loading={false}
                  >
                    <Image
                      src={`https://cdn.cloubot.com/EVN/middle/${preset}/image/${data?.study_quiz_data[done]['question_image']}`}
                      width={'100%'}
                      style={{ objectFit: 'contain' }}
                      preview={{
                        rootClassName: 'custom-preview',
                      }}
                    />
                  </Card>
                ) : isMobileOnly ? (
                  <></>
                ) : (
                  <Card
                    style={{
                      width: '100%',
                      borderRadius: 20,
                      boxShadow: '10px 10px 5px 5px rgba(95, 77, 99, 0.5)',
                      justifyContent: 'center',
                      alignItems: 'center',
                      display: 'flex',
                    }}
                    bodyStyle={{
                      background: '#fff',
                      borderRadius: 20,
                      minHeight: '300px',
                      display: 'flex',
                      cursor: 'default',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                    hoverable
                    loading={false}
                  >
                    <Image
                      height={100}
                      width={100}
                      style={{ cursor: 'pointer' }}
                      src="/images/evine-logo.png"
                      preview={false}
                      // onClick={() => setPlaying(true)}
                    />
                  </Card>
                )}
              </Col>
              <Col
                className={isMobileOnly ? 'word-board-option word-board-option-mobile' : 'word-board-option'}
                span={14}
                style={{
                  padding: '0 40px',
                  display: 'flex',
                  justifyContent: 'flex-start',
                  alignItems: 'flex-start',
                  flexDirection: 'column',
                }}
              >
                <Title
                  level={4}
                  style={{ width: '100%', background: '#c0daf1', marginLeft: 10, padding: 10, borderRadius: 10, display: 'flex' }}
                >
                  <div>
                    {error != -1 ? (
                      <StarOutlined
                        style={{ color: '#de3333', fontSize: '95px', position: 'absolute', marginTop: '-30px', marginLeft: '-30px' }}
                      />
                    ) : null}{' '}
                    {correct != -1 && error === -1 ? (
                      <svg
                        height="95"
                        width="95"
                        style={{ color: '#4dde33', fontSize: '95px', position: 'absolute', marginTop: '-30px', marginLeft: '-30px' }}
                      >
                        <circle cx="50" cy="50" r="40" stroke="#4dde33" strokeWidth="10" fill="transparent" />
                      </svg>
                    ) : null}{' '}
                    {`Q${done + 1}. `}
                  </div>
                  <span
                    style={{ marginLeft: 10 }}
                    dangerouslySetInnerHTML={{
                      __html: ` ${ques}`,
                    }}
                  ></span>
                </Title>

                {data?.study_quiz_data[done]['question_type'] !== 'B' ? (
                  options.map((v, i) => (
                    <Title
                      key={i}
                      level={4}
                      style={{
                        width: 'calc(100% - 20px)',
                        border: `3px solid #${error === i ? 'de3333' : correct === i ? '4dde33' : 'c0daf1'}`,
                        marginLeft: 30,
                        padding: 10,
                        borderRadius: 10,
                        cursor: 'pointer',
                      }}
                      onClick={() => handleAnswerClick(v, i)}
                    >{`${i + 1}. ${v}`}</Title>
                  ))
                ) : (
                  <ImgWrapper>
                    {options.map((v, i) => (
                      <OptionNumber
                        style={{ margin: 15, color: `#${error === i ? 'de3333' : correct === i ? '4dde33' : '000'}` }}
                        onClick={() => handleAnswerClick(v, i)}
                      >
                        {`${i + 1}.`}
                        <ImageOption
                          // height={200}
                          // width={200}
                          style={{ cursor: 'pointer' }}
                          src={`https://cdn.cloubot.com/EVN/middle/${preset}/image/${v}`}
                          preview={false}
                        />
                      </OptionNumber>
                    ))}
                  </ImgWrapper>
                )}
              </Col>
            </Row>
            {/* {data?.study_quiz_data[type === -1 ? 0 : done]['question_audio'] ? ( */}
            {/* ) : null} */}
          </MainBlock>
        )}
      </Col>
    </>
  );
};

export default LCQuizPage;
const ImgWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start; // 왼쪽 정렬
  gap: 20px;
  width: 100%;
  @media (max-width: 1280px) {
    gap: 10px;
  }
`;
const OptionNumber = styled.div`
  font-size: 38px;
  margin-bottom: 0.5em;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 600;
  line-height: 1.23;
  @media (max-width: 1280px) {
    font-size: 25px;
  }
`;
const ImageOption = styled(Image)`
  width: 200px;
  height: 200px;
  @media (max-width: 1280px) {
    width: 150px;
    height: 150px;
  }
  @media (max-width: 960px) {
    width: 120px;
    height: 120px;
  }
`;
